import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import classnames from 'classnames';

import SocialLinks from '../generalComponents/SocialLinks';
import footerLogo from '../../assets/nn-footer-logo-0065d828c6f63f8d94592011daa005e7.png';
import nakedNewsLiveLogo from '../../assets/NakedNewsLive/NNL_footer.png';
import { UserContext } from '../../context';
import { isNakedNewsLiveDomain } from '../../utils/helpers';
import { isGuestOrFreemiumUser } from '../../utils/getUserDetails';

import MemberFooterLinks from './MemberFooterLinks';


const today = new Date();
const currentYear = today.getFullYear();

const copyright = `
    Copyright, 1999-${currentYear} Naked Broadcasting Network Inc. All Rights Reserved.
    "Naked News" is a registered trademark of Egalaxy Multimedia Inc.
`;

const NakedNewsFooter = () => {
  const user = React.useContext(UserContext);
  const isAnchor = user.user && !!user.user.account.anchor;
  const shouldHideAffiliatesLink = window.location.pathname === '/affiliates';
  const logoToUse = isNakedNewsLiveDomain ? nakedNewsLiveLogo : footerLogo;
  const isGuestOrFreeUser = isGuestOrFreemiumUser(user);

  const guestStyle = classnames(
    'footer',
    { 'guest-footer': isGuestOrFreeUser }
  );

  return (
    <div className={guestStyle}>
      <div className="container">
        <div className="row-r footer-container">
          <div className="col-xs-12 text-center logo-section-footer">
            <img
              alt="Nn footer logo"
              className={`img-responsive ${!isMobileOnly ? '' : 'logo'}`}
              src={logoToUse}
            />
          </div>
          {!isMobileOnly && isAnchor ? null : (
            <>
              <div className="col-xs-12 text-center social-links-footer">
                <SocialLinks />
              </div>
              <div className="col-xs-12 text-center follow-us">
                <h3>FOLLOW US</h3>
              </div>
              <MemberFooterLinks
                isAnchor={isAnchor}
                isFreemiumUser={isGuestOrFreeUser}
                shouldHideAffiliatesLink={shouldHideAffiliatesLink}
                user={user}
              />
            </>
          )}
        </div>
        <p className="copy">{copyright}</p>
      </div>
    </div>
  );
};

export default React.memo(NakedNewsFooter);
